import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=392cc73d&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=392cc73d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cc73d",
  null
  
)

export default component.exports